import { Module } from 'vuex';
import { RootState, UserCategory } from 'frontend/types';

interface UserCategoryState {
  userCategory: UserCategory | null;
}

const userCategory: Module<UserCategoryState, RootState> = {
  namespaced: true,
  state: {
    userCategory: null,
  } as UserCategoryState,
  getters: {},
  mutations: {
    setValue(state: UserCategoryState, value: UserCategory) {
      state.userCategory = value;
    },
  },
};

export default userCategory;
